import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'
import { useVersionUpdateStore } from '@/stores/versionUpdate'

export default defineComponent({
  name: 'VersionUpdateToast',
  setup() {
    const { t } = useI18n()
    const store = useVersionUpdateStore()

    let headsUpToastId: string | number | null = null

    // Heads-up: fires once per SHA. Dismissal persists via store.dismissCurrent.
    watch(
      () => store.shouldShowHeadsUp,
      (show) => {
        if (show && headsUpToastId === null) {
          headsUpToastId = toast.info(t('versionUpdate.title'), {
            description: t('versionUpdate.message'),
            duration: Infinity,
            action: {
              label: t('versionUpdate.refreshNow'),
              onClick: () => {
                try {
                  store.markPendingReload()
                } catch (e) {
                  console.warn('markPendingReload failed', e)
                }
                window.location.reload()
              },
            },
            onDismiss: () => {
              // Reset id BEFORE dismissCurrent so the resulting `shouldShowHeadsUp`
              // flip to false hits the `else if (!show && headsUpToastId !== null)`
              // branch as a no-op (avoids double-dismissing).
              headsUpToastId = null
              store.dismissCurrent()
            },
            onAutoClose: () => {
              headsUpToastId = null
            },
          })
        } else if (!show && headsUpToastId !== null) {
          toast.dismiss(headsUpToastId)
          headsUpToastId = null
        }
      },
      { immediate: true },
    )

    // Confirmation: fires once after a silent reload delivered the new bundle.
    watch(
      () => store.justUpdatedToVersion,
      (version) => {
        if (version) {
          toast.success(t('versionUpdate.updatedTitle', { version }), {
            description: t('versionUpdate.updatedMessage'),
            duration: 5000,
          })
          store.clearJustUpdated()
        }
      },
      { immediate: true },
    )

    return () => null
  },
})
